import { spring, parallel, tween } from 'popmotion';
import { gsap } from 'gsap/all';
import { GLManager } from './HeaderGLManager';
import { reach } from './reach';

function Header(data, options = {}) {
    this.GL = new GLManager(data);
    this.GL.createPlane();

    this.data = data;

    this.progress = 0.8;
    this.direction = 0;
    this.waveIntensity = 2;
    this.GL.speed = 0.1;

    this.options = options;

    this.index = {
        target: 0,
        current: 0,
        initial: 0,
        scrollSize: window.innerHeight / 6,
        active: 0,
    };

    this.follower = {
        x: 0,
        y: 0,
    };

    this.followerSpring = null;
    this.slidesSpring = null;

    gsap.set('.case-header', { perspective: 1600 });
    this.GL.scheduleLoop();

    EventBus.$once('image-loaded', () => {
        this.onStart();
        gsap.set('canvas', {
            rotateX: 60, x: '0', y: '-40%', autoAlpha: 0,
        });
        gsap.delayedCall(0.8, () => {
            this.onGrabEnd();
            gsap.to('canvas', {
                duration: 0.2,
                autoAlpha: 1,
                delay: 0.2,
            });
            gsap.to('canvas', {
                duration: 0.7,
                rotateX: 0,
                y: '0%',
                ease: 'power3.easeOut',
            });
        });

        gsap.delayedCall(1.2, () => {
            // this.onGrabEnd();
        });
    });
}

Header.prototype.mount = function(container) {
    this.GL.mount(container);
};
Header.prototype.render = function() {
    this.GL.render();
};
function clamp(num, min, max) {
    return Math.max(min, Math.min(num, max));
}

Header.prototype.onGrabMove = function(scroll) {
    this.index.target = clamp(
        this.index.initial + scroll.delta / this.index.scrollSize,
        -this.data.length + 0.51,
        0.49,
    );

    const index = clamp(Math.round(-this.index.target), 0, this.data.length - 1);

    if (this.index.active !== index) {
        this.index.active = index;
        if (this.options.onActiveIndexChange) {
            this.options.onActiveIndexChange(this.index.active);
        }
        // this.slides.onActiveIndexChange(this.index.active);

        this.GL.updateTexture(index);
        if (this.textureProgressSpring) {
            this.textureProgressSpring.stop();
            this.textureProgressSpring = null;
        }
        this.textureProgressSpring = tween({
            from: 0,
            to: 1,
            duration: 600,
        }).start((val) => {
            this.GL.updateTexture(null, val);
        });
    }

    if (this.slidesPop) {
        this.slidesPop.stop();
    }
    this.slidesPop = reach({
        from: { index: this.index.current },
        to: { index: this.index.target },
        restDelta: 0.001,
    }).start({
        update: (val) => {
            // this.slides.onMove(index);
            if (this.options.onIndexChange) {
                this.options.onIndexChange(val.index);
            }
            this.index.current = val.index;
        },
        complete: (val) => {
            if (this.options.onIndexChange) {
                this.options.onIndexChange(val.index);
            }
            this.index.current = val.index;
        },
    });
};
Header.prototype.onStart = function(callback) {
    if (this.options.onZoomOutStart) {
        // alert('onZoomOutStart');
        this.options.onZoomOutStart({ activeIndex: this.index.active });
    }

    // this.slides.appear();
    this.index.initial = this.index.current;

    //   gsap.to('canvas', 0.4, { scale: 0, delay: 0.2 });
    //   gsap.to('canvas', 0.3, { autoAlpha: 0, delay: 0.4 });

    if (this.GLStickPop) {
        this.GLStickPop.stop();
    }
    this.progress = 1;
    this.direction = 1;
    this.waveIntensity = 0.2;

    this.GL.updateStickEffect({
        progress: this.progress,
        direction: this.direction,
        waveIntensity: this.waveIntensity,
    });

    this.GL.scheduleLoop();
};

Header.prototype.onSlowStop = function() {
    if (this.GLStickPop) {
        // this.GLStickPop.stop();
    }
    const directionSpring = spring({
        from: this.direction,
        to: this.direction,
        mass: 1,
        stiffness: 800,
        damping: 800,
    });
    const progressSpring = spring({
        from: this.progress,
        to: this.progress,
        mass: 4,
        stiffness: 400,
        damping: 70,
        restDelta: 0.01,
    });
    const waveIntensitySpring = spring({
        from: 0.2,
        to: 0,
        duration: 1500,
    });

    // this.GL.cancelLoop();
    // return;

    this.GLStickPop = parallel(
        progressSpring,
        directionSpring,
        waveIntensitySpring,
    ).start({
        update: (values) => {
            this.progress = values[0];
            this.direction = values[1];
            this.waveIntensity = values[2];
            this.GL.updateStickEffect({
                progress: this.progress,
                direction: this.direction,
                waveIntensity: this.waveIntensity,
            });
        },
        complete: () => {
            if (this.options.onFullscreenFinish) {
                this.options.onFullscreenFinish({ activeIndex: this.index.active });
            }
            // this.GL.cancelLoop();
            this.GLStickPop.stop();
            if (this.data[0].media.type === 'image') {
                this.GL.cancelLoop();
            }
            EventBus.$emit('scroll:update');
        },
    });
};

Header.prototype.onGrabEnd = function() {
    if (this.GLStickPop) {
        this.GLStickPop.stop();
    }
    const directionSpring = spring({
        from: this.progress === 1 ? 1 : this.direction,
        to: 1,
        mass: 1,
        stiffness: 800,
        damping: 800,
    });
    const progressSpring = spring({
        from: this.progress,
        to: 0.0,
        mass: 4,
        stiffness: 400,
        damping: 70,
        restDelta: 0.01,
    });
    const waveIntensitySpring = spring({
        from: this.waveIntensity,
        to: 0.2,
        mass: 0.6,
        stiffness: 800,
        damping: 50,
    });
    this.waveIntensity = 0.2;

    this.GLStickPop = parallel(
        progressSpring,
        directionSpring,
        waveIntensitySpring,
    ).start({
        update: (values) => {
            this.progress = values[0];
            this.direction = values[1];
            // this.waveIntensity = values[2];
            this.GL.updateStickEffect({
                progress: this.progress,
                direction: this.direction,
                waveIntensity: this.waveIntensity,
            });
        },
        complete: () => {
            if (this.options.onFullscreenFinish) {
                this.options.onFullscreenFinish({ activeIndex: this.index.active });
            }
            if (this.GLStickPop) {
                this.GLStickPop.stop();
                // this.GL.slowStop();
            }
            this.onSlowStop();
            // this.GL.slowStop();
            // this.GL.cancelLoop();
        },
    });
};

Header.prototype.onResize = function() {
    this.GL.onResize();
};
export { Header };
